import { API, authClient } from "..";

// Get all quizzes (optional: filter by game)
export const getQuizzes = (params = {}) => {
	return authClient().get(`${API}/quiz`, { params });
};

// Get the specified quiz
export const getQuizById = (id) => {
	return authClient().get(`${API}/quiz/${id}`);
};

// Update quiz (e.g. fullName, scenario, options)
export const updateQuiz = (id, body) => {
	return authClient().put(`${API}/quiz/${id}`, body);
};
